import {Input} from "../Form/types";
import {createTextInput} from "../Form/Input";
import {__} from "@wordpress/i18n";

export const InputLastName = (el: HTMLElement|null) => {
    return el
        ? createTextInput( el as HTMLInputElement, ( input: Input, value: string ): void => {
            if ( ! /^[A-Za-zÄÖÜäöüßÀ-ÿ' -]{2,50}$/.test( value.trim() ) ) {
                input.addError( __( 'Ungültiger Nachname.', 'dierck-group-company' ) );
            }
        } )
        : null;
}
